import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { selectCoinDepositList } from '@redux/selectors/userSelectors';
import { useAppSelector } from '@redux/store';

import { useVisitDailyBonus } from '@/common/hooks/visit-daily-bonus';

import { H1, StringSmall } from '../Typography/Typography';

import { DailyBanner } from './DailyBanner/DailyBanner';
import { OffersList } from './OffersList/OffersList';

import css from './styles.module.scss';

const CoinMarket: FC = () => {
  const { t } = useTranslation();
  const { withDiscount, list } = useAppSelector(selectCoinDepositList);
  useVisitDailyBonus();

  return (
    <div className="w-full h-full flex-1 flex flex-col items-center pt-12">
      <H1 weight="bold" className="mb-6 xl:text-xl">
        {t('Buy T-Gems')}
      </H1>
      <DailyBanner />
      {withDiscount && (
        <div className={css.firstBuy}>
          <StringSmall
            weight="bold"
            className="uppercase !text-golden-brown mr-2 text-nowrap xl:!text-[0.6875rem]"
          >
            {t('First-purchase bonus')}:
          </StringSmall>
          <StringSmall
            weight="black"
            className="!text-golden-brown uppercase !leading-none xl:!text-[0.6875rem]"
          >
            x2 t-gem
          </StringSmall>
        </div>
      )}
      <OffersList
        list={list.sort((a, b) => b.coin - a.coin)}
        isModal={false}
        source="shop"
      />
    </div>
  );
};

export { CoinMarket };
